import { TChipTheme, IChipColors } from './HBChip.types';
import { vars } from '../../theme';

/**
 * Get the color scheme for a chip based on its theme, selection state, and disabled state
 */
export const getChipColors = (
    theme: TChipTheme,
    selected: boolean,
    disabled: boolean
): IChipColors => {
    if (disabled) {
        return {
            bg: vars.colors.surface.disabled,
            text: vars.colors.text.disabled,
            border: selected
                ? vars.colors.stroke.selectedDisabled
                : vars.colors.stroke.disabled
        };
    }

    switch (theme) {
        case 'accent':
            return {
                bg: selected
                    ? vars.colors.surface.accent
                    : vars.colors.surface.item,
                text: selected
                    ? vars.colors.text.accent
                    : vars.colors.text.primary,
                border: selected
                    ? vars.colors.base.accent
                    : vars.colors.stroke.primary,
                hoverBg: selected
                    ? vars.colors.surface.accentHover
                    : vars.colors.surface.itemHover,
                pressedBg: selected
                    ? vars.colors.surface.accentPressed
                    : vars.colors.surface.itemPressed
            };
        default:
            return {
                bg: selected
                    ? vars.colors.surface.itemSelected
                    : vars.colors.surface.item,
                text: vars.colors.text.primary,
                border: selected
                    ? vars.colors.stroke.selected
                    : vars.colors.stroke.primary,
                hoverBg: selected
                    ? vars.colors.surface.itemSelectedHover
                    : vars.colors.surface.itemHover,
                pressedBg: selected
                    ? vars.colors.surface.itemSelectedPressed
                    : vars.colors.surface.itemPressed
            };
    }
};
